import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchAircraft } from '@/lib/aircraft';

export interface MapView {
  lat: number;
  lon: number;
  radiusNm: number;
}

/** Live aircraft around the current map view, refreshed every 12 s. */
export function useAircraft(view: MapView | null, enabled: boolean) {
  return useQuery({
    queryKey: ['aircraft', view?.lat, view?.lon, view?.radiusNm],
    queryFn: ({ signal }) => fetchAircraft(view as MapView, (view as MapView).radiusNm, signal),
    enabled: enabled && view !== null,
    refetchInterval: 12_000,
    staleTime: 5_000,
    placeholderData: keepPreviousData,
    retry: 1,
  });
}
